export default function loadRoutes(req) {
  let routes = [];

  const routeFiles = Object.keys(req);
  routeFiles.forEach(jsFile => {
    let thisFileRoutes = req[jsFile];
    if (thisFileRoutes.default) thisFileRoutes = thisFileRoutes.default; // handle ES6 syntax in view models that use export default { ...viewModeldeclaration... }

    routes = routes.concat(thisFileRoutes);
  });

  return routes;
}
